import TopUpManage from '@/pages/handle/topUpManage'

export default [
  {
    path: '/topUpManage',
    name: 'TopUpManage',
    component: TopUpManage,
    meta: { name: '充值处理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/handle/topUpManage.js